import { Component, Input } from '@angular/core';

@Component({
  selector: 'info-metadata-modal',
  template: `
    <div class="code-heading">
      <button type="button" name="copy-button" class="eva-3-btn-ghost -md" (click)="copyToClipboard(content)">
        <i class="eva-3-icon-copy -eva-3-icon-sm"></i><em class="btn-text"> Copiar código</em>
      </button>
    </div>
    <div class="code-preview">
      <pre><code>{{ content | json }}</code></pre>
    </div>`,
  styleUrls: ['./info-metadata-modal.component.scss']
})
export class InfoMetadataModalComponent {
  @Input() content: any;

  async copyToClipboard(text: string) {
    const json = JSON.stringify(text);
    // Navigator clipboard api needs a secure context (https)
    if (navigator.clipboard && window.isSecureContext) {
        await navigator.clipboard.writeText(json);
    } else {
        // Use the 'out of viewport hidden text area' trick
        const textArea = document.createElement("textarea");
        textArea.value = json;

        // Move textarea out of the viewport so it's not visible
        textArea.style.position = "absolute";
        textArea.style.left = "-999999px";
            
        document.body.prepend(textArea);
        textArea.select();

        try {
            console.log('Copying to clipboard:', text);
            document.execCommand('copy');
        } catch (error) {
            console.error(error);
        } finally {
            textArea.remove();
        }
    }
  }
}
